<p-card *ngIf="!EstCharge()">
    <app-loading [title]="'Chargement des emprunts'" [httpEvent]="loadingEvent" [error]="loadingError"></app-loading>
</p-card>

<p-card *ngIf="EstCharge()">
    <div class="mb-4">
        <h5 class="my-1">Emprunts</h5>
        <span class="text-500">Les emprunts sont des items d'inventaire uniques qui ont été empruntés par un employé.</span>
    </div>
    <div class="flex justify-content-between flex-wrap my-2">
        <div class="flex align-items-center gap-2 flex-wrap">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input autofocus pInputText type="text" [(ngModel)]="globalFilter"
                    (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Recherche..." />
            </span>
            <p-button label="Ajouter" icon="pi pi-plus" severity="success"
                (onClick)="nouveauEmprunt()"></p-button>
        </div>
        <div class="flex justify-content-end align-items-center">
            <app-selecteur-colonnes
                [colonnesDisponibles]="colonnesDisponibles"
                [(ngModel)]="colonnesSelectionnees"
                (onChange)="surChangementColonnes($event)"
                (onReset)="reinitialiserColonnesSelectionnees()">
            </app-selecteur-colonnes>
        </div>
    </div>
    <p-table #dt [value]="emprunts" [paginator]="true"
        [globalFilterFields]="['employe.nom', 'employe.prenom', 'statut.nom', 'departDescription', 'item.numeroDescription', 'employeFilter']"
        [rows]="200" [totalRecords]="emprunts?.length"
        [multiSortMeta]="sortMeta" sortMode="multiple"
        [paginatorDropdownAppendTo]="'body'" 
        (onFilter)="tableParams.setValue(dt)"
        (onSort)="tableParams.setValue(dt)"
        (onPage)="tableParams.setValue(dt)"
        responsiveLayout="stack">
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th *ngIf="EstColonneSelectionnee('item')" pSortableColumn="item.numeroDescription">
                    <div class="flex align-items-center gap-2">
                        Item
                        <p-sortIcon field="item.numeroDescription"></p-sortIcon>
                        <p-columnFilter field="item.numeroDescription" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('emplacementDepart')" pSortableColumn="emplacementDepart.nom">
                    <div class="flex align-items-center gap-2">
                        Départ
                        <p-sortIcon field="emplacementDepart.nom"></p-sortIcon>
                        <p-columnFilter field="emplacementDepart.nom" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('employe')" pSortableColumn="employe.nom">
                    <div class="flex align-items-center gap-2">
                        Employé
                        <p-sortIcon field="employe.nom"></p-sortIcon>
                        <p-columnFilter field="employeFilter" matchMode="employeEmplacementFilter" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" [showResetButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <app-assignation-filter
                                    [(ngModel)]="selectionAssignations"
                                    (onChange)="filter($event)">
                                </app-assignation-filter>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('statut')" pSortableColumn="statut.nom">
                    <div class="flex align-items-center gap-2">
                        Statut
                        <p-sortIcon field="statut.nom"></p-sortIcon>
                        <p-columnFilter field="statut.statutId" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Tous"
                                    (onChange)="filter($event.value)" optionLabel="nom" optionValue="statutId" dataKey="statutId">
                                    <ng-template let-option pTemplate="item">
                                        <div class="multiselect-representative-option">
                                            <span class="ml-1">{{option.nom}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('dateAffectation')" pSortableColumn="dateAffectation">
                    <div class="flex align-items-center gap-2">
                        Date de début
                        <p-sortIcon field="dateAffectation"></p-sortIcon>
                        <p-columnFilter field="dateAffectation" type="date" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('dateRetour')" pSortableColumn="dateRetour">
                    <div class="flex align-items-center gap-2">
                        Date de retour
                        <p-sortIcon field="dateRetour"></p-sortIcon>
                        <p-columnFilter field="dateRetour" type="date" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('emplacementRetour')" pSortableColumn="emplacementRetour.nom">
                    <div class="flex align-items-center gap-2">
                        Emplacement retour
                        <p-sortIcon field="emplacementRetour.nom"></p-sortIcon>
                        <p-columnFilter field="emplacementRetour.nom" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('employeRetour')" pSortableColumn="employeRetour.nom">
                    <div class="flex align-items-center gap-2">
                        Employé retour
                        <p-sortIcon field="employeRetour.nom"></p-sortIcon>
                        <p-columnFilter field="employeRetour.nom" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th *ngIf="EstColonneSelectionnee('nbEmpruntsEnfants')" pSortableColumn="nbEmpruntsEnfants">
                    <div class="flex align-items-center gap-2">
                        Nb. d'enfants
                        <p-sortIcon field="nbEmpruntsEnfants"></p-sortIcon>
                        <p-columnFilter field="nbEmpruntsEnfants" type="number" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-emprunt>
            <tr>
                <td>
                    <div *ngIf="emprunt.item.photoId">
                        @defer (on viewport) {
                        <app-image-loader [documentId]="emprunt.item.photoId" [width]="40" [height]="40" [title]="emprunt.item.numero"></app-image-loader>
                        }
                        @placeholder {
                            <div class="flex align-items-center justify-content-center" style="height: 40px; width: 40px;">
                                <p-skeleton width="40px" height="40px"></p-skeleton>
                            </div>
                        }
                    </div>
                </td>
                <td *ngIf="EstColonneSelectionnee('item')">
                    <div class="flex flex-column gap-2">
                        <span *ngIf="isMobile" class="p-column-title">Item</span>
                        {{emprunt.item.numeroDescription}}
                    </div>
                </td>
                <td *ngIf="EstColonneSelectionnee('emplacementDepart')">
                    <span class="p-column-title">Départ</span> 
                    <i *ngIf="emprunt?.emplacementDepart" class="pi pi-map-marker"></i>
                    <i *ngIf="emprunt?.employeDepart" class="pi pi-user"></i>
                    {{emprunt?.emplacementDepart?.nom || (emprunt?.employeDepart?.prenom + ' ' + emprunt?.employeDepart?.nom)}}
                </td>
                <td *ngIf="EstColonneSelectionnee('employe')"><span class="p-column-title">Employé</span><app-employe-avec-emplacement [employe]="emprunt.employe"></app-employe-avec-emplacement></td>
                <td *ngIf="EstColonneSelectionnee('statut')">
                    <span class="p-column-title">Statut</span>
                    <span class="statut {{emprunt.statut.nom | statut}}">{{emprunt.statut.nom}}</span> 
                    <span *ngIf="emprunt.statut.nom == 'En retard'"> depuis <strong [class.text-danger]="getNombreJoursEnRetard(emprunt) > 0">{{getNombreJoursEnRetard(emprunt)}}</strong> jours</span>
                    <span *ngIf="emprunt.statut.nom == 'Actif' && emprunt.dateRetour"> reste <strong>{{getNombreJoursEnRetard(emprunt)}}</strong> jours</span>
                </td>
                <td *ngIf="EstColonneSelectionnee('dateAffectation')"><span class="p-column-title">Date de début</span>{{emprunt.dateAffectation | date:'dd/MM/yyyy'}}</td>
                <td *ngIf="EstColonneSelectionnee('dateRetour')"><span class="p-column-title">Date de retour</span>{{emprunt.dateRetour | date:'dd/MM/yyyy' || 'Aucune date de retour'}}</td>
                <td *ngIf="EstColonneSelectionnee('emplacementRetour')"><span class="p-column-title">Emplacement retour</span>{{emprunt?.emplacementRetour?.nom || 'N/A'}}</td>
                <td *ngIf="EstColonneSelectionnee('employeRetour')"><span class="p-column-title">Employé retour</span><app-employe-avec-emplacement *ngIf="emprunt?.employeRetour" [employe]="emprunt.employeRetour"></app-employe-avec-emplacement><span *ngIf="!emprunt?.employeRetour">N/A</span></td>
                <td *ngIf="EstColonneSelectionnee('nbEmpruntsEnfants')"><span class="p-column-title">Nb. d'enfants</span>{{emprunt.nbEmpruntsEnfants}}</td>
                <td>
                    <div class="flex justify-content-end gap-1">
                        <p-button icon="pi pi-eye" severity="success" size="small" [routerLink]="['/emprunt', emprunt.empruntId]" [label]="isMobile ? 'Voir' : ''"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="colonnesSelectionnees.length + 1" class="text-center">
                    <div class="flex align-items-center justify-content-center gap-2">
                        <i class="pi pi-info-circle"></i>
                        <span>Aucun emprunt trouvé</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>